import { useState } from "react";
import AdminSidebar from "@/pages/admin/components/AdminSidebar";
import ReviewsTab from "@/pages/admin/components/ReviewsTab";
import InquiriesTab from "@/pages/admin/components/InquiriesTab";
import ChannelSettingsTab from "@/pages/admin/components/ChannelSettingsTab";
import AirbnbSettingsTab from "@/pages/admin/components/AirbnbSettingsTab";
import AdminLogin, { SESSION_KEY } from "@/pages/admin/components/AdminLogin";

export type AdminTab = "reviews" | "inquiries" | "channels" | "airbnb";

export default function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    () => sessionStorage.getItem(SESSION_KEY) === "true"
  );
  const [activeTab, setActiveTab] = useState<AdminTab>("reviews");

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <AdminLogin onAuthenticated={() => setIsAuthenticated(true)} />;
  }

  const renderTab = () => {
    switch (activeTab) {
      case "reviews": return <ReviewsTab />;
      case "inquiries": return <InquiriesTab />;
      case "channels": return <ChannelSettingsTab />;
      case "airbnb": return <AirbnbSettingsTab />;
      default: return <ReviewsTab />;
    }
  };

  return (
    <div className="flex min-h-screen bg-[#f7f6f3]">
      <AdminSidebar activeTab={activeTab} onTabChange={setActiveTab} onLogout={handleLogout} />
      <main className="flex-1 ml-64 p-8 min-h-screen">
        {renderTab()}
      </main>
    </div>
  );
}
